import { useMemo } from 'react';
import { CmsOffer } from '../types/cmsProduct';
import { PersonalLoanFilterConfig } from '../utils/helpers';
import { filterOffersByAmountAndTenure } from '../utils/helpers/offers';
import { LoanSearchParams } from '../utils/searchParams/loanSearchParams';

const useOfferFilterLoanParams = (props: {
  welcomeOffer: CmsOffer[];
  exclusiveOffer: CmsOffer[];
  loanParams: LoanSearchParams | undefined;
  plFilterConfig: PersonalLoanFilterConfig | undefined;
}) => {
  const { welcomeOffer, exclusiveOffer, loanParams, plFilterConfig } = props;
  const { amount, tenure } = loanParams ?? {};

  const productExclusiveOffer = useMemo(
    () =>
      filterOffersByAmountAndTenure(
        exclusiveOffer,
        amount,
        tenure,
        plFilterConfig,
      ),
    [exclusiveOffer, amount, tenure, plFilterConfig],
  );

  const productWelcomeOffer = useMemo(
    () =>
      filterOffersByAmountAndTenure(
        welcomeOffer,
        amount,
        tenure,
        plFilterConfig,
      ),
    [welcomeOffer, amount, tenure, plFilterConfig],
  );

  return {
    productExclusiveOffer,
    productWelcomeOffer,
  };
};

export default useOfferFilterLoanParams;
